//@flow

import slugify from '@sindresorhus/slugify';
import capitalize from 'lodash/capitalize';

type types = {
  lodgeName: string,
  lodgeId: string,
  placeName: string,
  dayDate: string,
  trekId: string,
  dayNo: number,
  segmentId: string,
  isAdded: boolean,
  day: number,
};

const resolveRegion = region => (region ? `.${slugify(region)}-region` : '');

const makeUrl = {
  goToLandingPage: '/',
  goToExplore: '/explore',
  goToGuideListings: '/guides',
  goToTreks: '/treks',
  goToPlaces: '/places',
  goToLodge: '/lodges',
  goToFlight: '/flights/all',
  goToTransportation: '/transportation',
  goToBlog: '/blog/',

  trekOverview: (name: string, id: string, region: string) =>
    `/treks/${slugify(name)}.${id}${resolveRegion(region)}`,

  placeDetails: (name: string, id: string, region: string) =>
    `/${slugify(name)}.${id}${resolveRegion(region)}`,

  goToDay: (name: string, id: string, dayNumber: number, region: string) =>
    `/treks/${slugify(name)}.${id}${resolveRegion(region)}/day-${dayNumber}`,

  goToLodgeFromPlace: (lodgeName: string, lodgeId: string, placeName: string) =>
    `/${slugify(lodgeName)}.${lodgeId}.${slugify(placeName)}-lodges`,

  goToProfile: (name: string, id: string) =>
    `/${name ? slugify(name) : 'newtrekker'}.${id}`,

  goToSettings: (id: string) => `/${id}.settings`,

  goToFlights: (url: string) => `/flights?${url}`,

  lodgePaymentPage: (bookingId: string) => `/payment?type=lodge&bookingId=${bookingId}`,

  trekPaymentPage: (invoiceId: string, trekId: string) =>
    `/payment?type=trek&bookingId=${invoiceId}&trekId=${trekId}`,

  customerDetails: (trek: Object, invoiceId: string) =>
    `/treks/${slugify(trek.name)}.${trek.id}${resolveRegion(
      trek.region
    )}/customer-details/${invoiceId}`,

  goToRegionInfo: (region: string) =>
    capitalize(region) === 'Everest'
      ? '/p/everything-about-the-everest-base-camp-trek/'
      : capitalize(region) === 'Annapurna'
      ? '/p/everything-about-the-annapurna-circuit-trek/'
      : '/explore',

  goToLodgeFromDay: ({
    lodgeName,
    lodgeId,
    placeName,
    dayDate,
    trekId,
    dayNo,
    segmentId,
    isAdded,
  }: types) =>
    `/${slugify(lodgeName)}.${lodgeId}.${slugify(
      placeName
    )}-lodges?dd=${dayDate}&tid=${trekId}&dN=${dayNo}&sid=${segmentId}&isAdded=${isAdded}`,
  goToLodgeDetails: (lodgeName: string, lodgeId: string, placeName: string) =>
    `/${slugify(lodgeName)}.${lodgeId}.${slugify(placeName)}-lodges`,

  goToSignUpVerficationSent: '/verfied',
  signup: {
    peningVerification: '/signup/pending-verification',
    activate: token => `/signup/activate/${token}`,
  },
};

export default makeUrl;



// WEBPACK FOOTER //
// ./src/lib/makeUrl.js